/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_No_Groups_AvailableInputs */



/**
* | output |
* | --- |
* | "No groups available. Create groups first to manage permissions." |
*
* @param {Knp_Manager_No_Groups_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_no_groups_available = /** @type {((inputs?: Knp_Manager_No_Groups_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_No_Groups_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe disponible. Créez d’abord des groupes pour gérer les autorisations.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es sind keine Gruppen verfügbar. Erstellen Sie zuerst Gruppen, um Berechtigungen zu verwalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo disponibile. Crea prima i gruppi per gestire le autorizzazioni.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет доступных групп. Сначала создайте группы, чтобы управлять правами доступа.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay grupos disponibles. Cree grupos primero para administrar los permisos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无可用群组。请先创建群组以管理权限。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なグループがありません。権限を管理するには、まずグループを作成してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई समूह उपलब्ध नहीं है। अनुमतियों को प्रबंधित करने के लिए पहले समूह बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há grupos disponíveis. Crie grupos primeiro para gerenciar permissões.")
	return /** @type {LocalizedString} */ ("No groups available. Create groups first to manage permissions.")
});